import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

  constructor() { }

  public abilityOverflow() {
    let body = document.querySelector('body');
    let html = document.querySelector('html');
    html.style.overflowY = "visible";
    body.style.overflowY = "visible";
  }
  public disableOverflow() {
    let body = document.querySelector('body');
    let html = document.querySelector('html');
    html.style.overflowY = "hidden";
    body.style.overflowY = "hidden";
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utils.service.ts